"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axlsign_1 = require("../libs/axlsign");
var param_1 = require("../conversions/param");
var util_1 = require("./util");
var address_keys_seed_1 = require("./address-keys-seed");
var crypto_1 = require("crypto");
exports.signBytes = function (seedOrPrivateKey, bytes, random) {
    return axlsign_1.default.sign(param_1._fromIn(util_1.isPrivateKey(seedOrPrivateKey)
        ? seedOrPrivateKey.privateKey
        : address_keys_seed_1.privateKey(seedOrPrivateKey)), param_1._fromIn(bytes), param_1._fromIn(random || crypto_1.randomBytes(64)));
};
//# sourceMappingURL=sign.js.map